/**
 * @file ContextSwitcher.tsx
 * @description Dropdown переключения AccountContext (phase08.5 shadcn).
 *
 * phase19.29: само переключение вынесено в `hooks/useContextSwitch` — им же
 * пользуется меню пользователя внизу боковой панели кабинета платформы
 * (`SidebarUserMenu`); разметка переключателя в шапке прежняя.
 */

import { ChevronDown } from "lucide-react";

import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { formatContextLabel } from "../auth/format";
import { useAuth } from "../auth/hooks";
import { useContextSwitch } from "../hooks/useContextSwitch";

export function ContextSwitcher() {
  const { me } = useAuth();
  const onPick = useContextSwitch();

  if (!me || me.contexts.length <= 1) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={(props) => (
          <Button {...props} variant="ghost" size="sm">
            Сменить контекст
            <ChevronDown className="size-4" />
          </Button>
        )}
      />
      <DropdownMenuContent align="end" sideOffset={6} className="min-w-72">
        {me.contexts.map((ctx) => {
          const isActive = ctx.id === me.activeContext?.id;
          return (
            <DropdownMenuItem
              key={ctx.id}
              disabled={isActive}
              onClick={() => void onPick(ctx)}
              className="flex-col items-start gap-0.5 py-2"
            >
              <span className="text-sm font-medium text-on-surface">
                {formatContextLabel(ctx)}
              </span>
              <span className="text-xs text-on-surface-variant">
                {ctx.role.code}
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
